<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="monthItemDataTableHeaders"
          :items="monthItemList"
          :search="searchMonthItem"
          class="elevation-1"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          item-key="Name"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="{ item, expand, isExpanded, index }">
            <tr>
              <td class="text-start">{{ item.Number }}</td>
              <td class="text-start">{{ item.Name }}</td>
              <td class="text-end">{{ item.Quantity }}</td>
              <td class="text-end">{{ item.AddPayQuantity }}</td>
              <td class="text-end">{{ item.RentQuantity }}</td>
              <td class="text-start">{{ item.Unit }}</td>
              <td class="text-end">{{ item.Price }}</td>
              <td class="text-end">{{ item.Discount }}</td>
              <td class="text-end">{{ item.DiscountPrice }}</td>
              <td class="text-end">{{ item.TotalPrice }}</td>
              <td class="text-end">{{ item.RentWarrantyPeriod }}</td>
              <td class="text-center">{{ turnPayType(item.PayType) }}</td>
              <td class="text-center">{{ turnPayTimeRangeTypeName(item.PayTimeRangeType) }}</td>
              <td class="text-center">{{ turnPayQuantityTypeName(item.PayQuantityType) }}</td>
              <td class="text-start">{{ item.Remark }}</td>
              <td class="text-center">
                <v-btn
                  icon
                  @click="isShowEditMonthItemDialogBtn(item, index, -1)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeleteMonthItemDialogBtn(item, index, -1)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  @click="upMonthItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-arrow-up-drop-circle-outline
                </v-icon>
                <v-icon
                  @click="downMonthItem(item)"
                  v-if="index !== monthItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-arrow-down-drop-circle-outline
                </v-icon>
              </td>
              <td v-if="item.Number"></td>
              <td v-if="!item.Number" class="text-start">
                <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                  mdi-chevron-up
                </v-icon>
                <v-icon @click="expand(!isExpanded)" v-else>
                  mdi-chevron-down
                </v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:expanded-item="{ item, index }">
            <tr v-for="(field, idx) in item.MonthBomItems" :key="field.Number">
              <td class="text-start">{{ field.Number }}</td>
              <td class="text-start">{{ field.Name }}</td>
              <td class="text-end">{{ field.Quantity }}</td>
              <td class="text-end">{{ field.AddPayQuantity }}</td>
              <td class="text-end">{{ field.RentQuantity }}</td>
              <td class="text-start">{{ field.Unit }}</td>
              <td class="text-end">{{ field.Price }}</td>
              <td class="text-end">{{ field.Discount }}</td>
              <td class="text-end">{{ field.DiscountPrice }}</td>
              <td class="text-end">{{ field.TotalPrice }}</td>
              <td class="text-end">{{ field.RentWarrantyPeriod }}</td>
              <td class="text-center">{{ turnPayType(field.PayType) }}</td>
              <td class="text-center">{{ turnPayTimeRangeTypeName(field.PayTimeRangeType) }}</td>
              <td class="text-center">{{ turnPayQuantityTypeName(field.PayQuantityType) }}</td>
              <td class="text-start">{{ field.Remark }}</td>
              <td class="text-center">
                <v-btn
                  icon
                  @click="isShowEditMonthItemDialogBtn(field, index, idx)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeleteMonthItemDialogBtn(field, index, idx)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
              <td></td>
              <td></td>
            </tr>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('quotation_item_new_tool_bar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchMonthItem"
                append-icon="mdi-magnify"
                :label="$t('quotation_item_new_install_search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
              <v-btn
                color="primary"
                class="mb-2 ml-8"
                :disabled="isAllTextFieldDisabled"
                @click="openMonthItem"
              >
                {{ $t('quotation_item_new_install_new_item_btn') }}
              </v-btn>
              <v-dialog
                v-model="isShowEditMonthItemDialog"
                v-if="isShowEditMonthItemDialog"
                persistent
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('quotation_item_new_month') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <ValidationObserver ref="dialogMonthItem">
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <month-item-autocomplete
                              :fatherEditedItem="editedMonthItem"
                              :itemName="'quotation_item_number'"
                              @setEditedMonthItem="setEditedMonthItem"
                              v-if="editedMonthItemIndex === -1"
                              refName="monthItemAutocomplete"
                              @keyupEnter="focusNextInput"
                            />
                            <ValidationProvider
                              :name="$t('quotation_item_number')"
                              rules="required"
                              v-slot="{ errors }"
                              v-else
                            >
                              <v-text-field
                                v-model="editedMonthItem.Number"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_number') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Name"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_name') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_unit')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Unit"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_unit') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('month_quantity')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Quantity"
                                :error-messages="errors[0]"
                                suffix="個月"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                                :disabled="isMonthBomItem"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('month_quantity') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedMonthItem.PayType === payType.Quantity"
                          >
                            <ValidationProvider
                              name="新增計量數量"
                              :rules="{ required: true, regex: /^\d+\.?\d*$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.AddPayQuantity"
                                :error-messages="errors[0]"
                                suffix="個"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                                :disabled="isMonthBomItem"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計量數量
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Price"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Discount"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣後單價"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.DiscountPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣後單價
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_total_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.TotalPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_total_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_rent_warranty_period')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.RentWarrantyPeriod"
                                :error-messages="errors[0]"
                                @keyup.enter="focusNextInput"
                                :disabled="isMonthBomItem"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_rent_warranty_period') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="收款方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayType"
                                :items="allPayType"
                                item-text="Name"
                                item-value="Type"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_data')"
                                @keyup.enter="setPayTypeAutocomplete"
                                @change="onPayTypeChange"
                                ref="payTypeAutocomplete"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  收款方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <ValidationProvider
                              name="計費時間"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayTimeRangeType"
                                :items="payTimeRangeTypeList"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計費時間
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            v-if="editedMonthItem.PayType === payType.Quantity"
                            cols="12"
                            sm="6"
                            md="3"
                            lg="3"
                            xl="3"
                          >
                            <ValidationProvider
                              name="計量方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayQuantityType"
                                :items="allPayQuantityType"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計量方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              :label="$t('quotation_item_remark')"
                              v-model="editedMonthItem.Remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedMonthItem">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="saveEditedMonthItem">
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <delete-dialog
                :isAllTextFieldDisable="false"
                :isLoadingSaveBtn="false"
                :isShowDeleteDialog="isShowDeleteMonthItemDialog"
                :deleteMessage="'quotation_item_delete_item_dialog_title'"
                @closeDelete="closeDeleteMonthItem"
                @confirmDelete="confirmDeleteMonthItem"
              />
              <v-btn
                color="primary"
                class="mb-2 ml-8"
                :disabled="isAllTextFieldDisabled"
                @click="openBomMonthItem"
              >
                新增月租BOM
              </v-btn>
              <v-dialog
                v-model="isShowEditBomMonthItemDialog"
                v-if="isShowEditBomMonthItemDialog"
                persistent
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('quotation_item_new_month') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <ValidationObserver ref="dialogMonthItem">
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_name')"
                              rules="required"
                              v-slot="{ errors }"
                              v-if="editedMonthItemIndex === -1"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.Name"
                                :items="monthBomList"
                                item-text="Name"
                                item-value="Id"
                                return-object
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_results')"
                                :disabled="editedMonthItemIndex !== -1"
                                :error-messages="errors[0]"
                                :loading="isLoading"
                                @click="getAllMonthBoms"
                                @change="setMonthBomItem"
                                ref="bomNameAutocomplete"
                                @keyup.enter="setBomName"
                              >
                                <template v-slot:item="data">
                                  <template>
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        {{ data.item.Name }}
                                      </v-list-item-title>
                                      <v-list-item-subtitle>
                                        {{ data.item.Describe }}
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </template>
                                </template>
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_name') }}
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                            <v-text-field
                              v-else
                              disabled
                              v-model="editedMonthItem.Name"
                              :label="$t('quotation_item_name')"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('month_quantity')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Quantity"
                                :error-messages="errors[0]"
                                suffix="個月"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('month_quantity') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedMonthItem.PayType === payType.Quantity"
                          >
                            <ValidationProvider
                              name="新增計量數量"
                              :rules="{ required: true, regex: /^\d+\.?\d*$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.AddPayQuantity"
                                :error-messages="errors[0]"
                                suffix="個"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                                :disabled="isMonthBomItem"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  新增計量數量
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_unit')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Unit"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_unit') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Price"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Discount"
                                :error-messages="errors[0]"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="折扣後單價"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.DiscountPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  折扣後單價
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_total_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.TotalPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_total_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_rent_warranty_period')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.RentWarrantyPeriod"
                                :error-messages="errors[0]"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_rent_warranty_period') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              name="收款方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayType"
                                :items="allPayType"
                                item-text="Name"
                                item-value="Type"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_data')"
                                @keyup.enter="setPayTypeAutocomplete"
                                @change="onPayTypeChange"
                                ref="payTypeAutocomplete"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  收款方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <ValidationProvider
                              name="計費時間"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayTimeRangeType"
                                :items="payTimeRangeTypeList"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計費時間
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            v-if="editedMonthItem.PayType === payType.Quantity"
                            cols="12"
                            sm="6"
                            md="3"
                            lg="3"
                            xl="3"
                          >
                            <ValidationProvider
                              name="計量方式"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayQuantityType"
                                :items="allPayQuantityType"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  計量方式
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              :label="$t('quotation_item_remark')"
                              v-model="editedMonthItem.Remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedBomMonthItem">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="saveEditedBomMonthItem">
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <delete-dialog
                :isAllTextFieldDisable="false"
                :isLoadingSaveBtn="false"
                :isShowDeleteDialog="isShowDeleteBomMonthItemDialog"
                :deleteMessage="'quotation_item_delete_item_dialog_title'"
                @closeDelete="closeDeleteBomMonthItem"
                @confirmDelete="confirmDeleteBomMonthItem"
              />
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import MonthItemAutocomplete from '@/components/MonthItemAutocomplete.vue'
import { PayType } from '@/js/PayType'
import { HttpMonthBom, HttpMonth } from '@/js/http-Manager'
import { PayTimeRangeType } from '@/js/PayTimeRangeType'
import { PayQuantityType } from '@/js/PayQuantityType'

export default {
  components: { MonthItemAutocomplete, DeleteDialog },
  name: 'NewMonthSetting',

  data: () => ({
    payQuantityType: PayQuantityType,
    payType: PayType,
    searchMonthItem: '',
    editedMonthItemIndex: -1,
    editedMonthBomItemIndex: -1,
    isShowEditMonthItemDialog: false,
    isShowDeleteMonthItemDialog: false,
    editedMonthItem: {
      Number: '',
      Name: '',
      Quantity: 1,
      PayQuantity: 0,
      AddPayQuantity: 1,
      RentQuantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      PayType: 1,
      PayTimeRangeType: 1,
      PayQuantityType: 1
    },
    defaultMonthItem: {
      Number: '',
      Name: '',
      Quantity: 1,
      PayQuantity: 0,
      AddPayQuantity: 1,
      RentQuantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      PayType: 1,
      PayTimeRangeType: 1,
      PayQuantityType: 1
    },
    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/,
    regexDecimal: /^\d+\.?\d*$/,
    monthBomList: [],
    isShowEditBomMonthItemDialog: false,
    isShowDeleteBomMonthItemDialog: false,
    payTimeRangeTypeList: []
  }),
  async mounted () {
    await this.getAllMonthBoms()
    await this.getAllPayTimeRangeType()
  },
  computed: {
    isMonthBomItem () {
      return this.editedMonthItemIndex !== -1 && this.editedMonthBomItemIndex !== -1
    },
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('month_quantity'), align: 'end', value: 'Quantity' },
        { text: '新增計量數量', align: 'end', value: 'AddPayQuantity' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: '收費方式', align: 'center', value: 'PayType' },
        { text: '計費時間', align: 'center', value: 'PayTimeRangeType' },
        { text: '計量方式', align: 'center', value: 'PayQuantityType' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    }
  },
  methods: {
    onPayTypeChange () {
      this.editedMonthItem.PayQuantityType = this.payQuantityType.Determined
    },
    turnPayQuantityTypeName (val) {
      return PayQuantityType.PayQuantityTypeName(val)
    },
    turnPayTimeRangeTypeName (val) {
      return PayTimeRangeType.PayTimeRangeTypeName(val)
    },
    async getAllPayTimeRangeType () {
      let response = await HttpMonth.GetPayTimeRangeTypes()
      this.payTimeRangeTypeList = response.status === 200 ? response.data.Data : []
    },
    async getAllMonthBoms () {
      let response = await HttpMonthBom.GetAllMonthBoms()
      this.isLoading = true
      this.monthBomList = response.status === 200 ? response.data.Data : []
      this.isLoading = false
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    setPayTypeAutocomplete (event) {
      this.$refs.payTypeAutocomplete.isMenuActive = false
      this.$refs.payTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    downMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllMonth', temp)
    },
    upMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.monthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllMonth', temp)
    },
    changeMonthTotal () {
      if (
        this.regexQuantity.test(this.editedMonthItem.RentQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.Price) &&
        this.regexDecimal.test(this.editedMonthItem.PayQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.AddPayQuantity) &&
        this.regexQuantity.test(this.editedMonthItem.Quantity) &&
        this.regexDecimal.test(this.editedMonthItem.Discount) &&
        this.regexDecimal.test(this.editedMonthItem.DiscountPrice)
      ) {
        this.editedMonthItem.DiscountPrice =
          this.editedMonthItem.Price - this.editedMonthItem.Discount
        const quantityMultiplier =
          this.editedMonthItem.PayType === this.payType.Quantity
            ? Math.max(
              0,
              this.editedMonthItem.AddPayQuantity * 1 + this.editedMonthItem.PayQuantity * 1
            )
            : 1
        this.editedMonthItem.TotalPrice =
          this.editedMonthItem.RentQuantity *
          this.editedMonthItem.DiscountPrice *
          this.editedMonthItem.Quantity *
          quantityMultiplier *
          1
      }
    },
    setEditedMonthItem (val) {
      this.editedMonthItem.Id = val.Id
      this.editedMonthItem.Number = val.Number
      this.editedMonthItem.Name = val.Name
      this.editedMonthItem.Unit = val.Unit
      this.editedMonthItem.Price = val.Price
      this.editedMonthItem.IsMonthItem = val.IsMonthItem
      this.editedMonthItem.IsDelete = val.IsDelete
      this.editedMonthItem.StoreNo = val.StoreNo
      this.editedMonthItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedMonthItem.Remark = val.Remark
      this.changeMonthTotal()
      this.editedMonthItem = JSON.parse(JSON.stringify(this.editedMonthItem))
    },
    closeEditedMonthItem () {
      this.isShowEditMonthItemDialog = false
      this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
      this.editedMonthItemIndex = -1
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
    },
    openMonthItem () {
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.isShowEditMonthItemDialog = true
    },

    closeDeleteMonthItem () {
      this.editedMonthItemIndex = -1
      this.isShowDeleteMonthItemDialog = false
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
    },

    async saveEditedMonthItem () {
      const isValid = await this.$refs.dialogMonthItem.validate()
      if (isValid) {
        this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
        this.$emit('setMonthBomItemIndex', this.editedMonthBomItemIndex)
        this.$emit('setMonthItem', this.editedMonthItem)
        if (this.isMonthBomItem && this.editedMonthItemIndex !== -1) {
          this.$emit('setBomMonth')
        }
        this.closeEditedMonthItem()
      }
    },

    confirmDeleteMonthItem () {
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
      this.$emit('setMonthBomItemIndex', this.editedMonthBomItemIndex)
      this.$emit('deleteMonthItem')
      if (this.isMonthBomItem) {
        this.$emit('setBomMonth')
      }
      this.closeDeleteMonthItem()
    },
    openBomMonthItem () {
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.isShowEditBomMonthItemDialog = true
    },
    isShowEditMonthItemDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number || item.Number === '') {
        this.editedMonthItemIndex = mainIndex
        this.editedMonthBomItemIndex = subIndex
        this.editedMonthItem = JSON.parse(JSON.stringify(item))
        this.isShowEditBomMonthItemDialog = true
      } else {
        this.editedMonthBomItemIndex = subIndex
        this.editedMonthItemIndex = mainIndex
        this.editedMonthItem = JSON.parse(JSON.stringify(item))
        this.isShowEditMonthItemDialog = true
      }
    },
    setMonthBomItem () {
      this.editedMonthItem.Quantity = this.editedMonthItem.Name.Quantity
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.editedMonthItem.TotalQuantity =
        this.editedMonthItem.Quantity * this.editedMonthItem.RentQuantity
      this.editedMonthItem.TotalPrice =
        this.editedMonthItem.TotalQuantity * this.editedMonthItem.Name.Price
      this.editedMonthItem.Id = this.editedMonthItem.Name.Id
      this.editedMonthItem.Price = this.editedMonthItem.Name.Price
      this.editedMonthItem.Number = this.editedMonthItem.Name.Number
      this.editedMonthItem.Unit = this.editedMonthItem.Name.Unit
      this.editedMonthItem.Remark = this.editedMonthItem.Name.Describe
      this.editedMonthItem.MonthBomItems = this.editedMonthItem.Name.MonthBomItems
      this.changeMonthTotal()
    },
    async saveEditedBomMonthItem () {
      const isValid = await this.$refs.dialogMonthItem.validate()
      if (isValid) {
        this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
        this.$emit('setMonthBomItemIndex', this.editedMonthBomItemIndex)
        if (this.editedMonthItem.Name.Name) {
          this.editedMonthItem.Name = this.editedMonthItem.Name.Name
        }
        this.editedMonthItem.MonthBomItems.forEach((element, index) => {
          element.Quantity = this.editedMonthItem.Quantity * 1
          element.AddPayQuantity = this.editedMonthItem.AddPayQuantity * 1
          element.PayQuantity = this.editedMonthItem.PayQuantity * 1
          element.RentQuantity = this.editedMonthItem.RentQuantity * 1
          element.TotalQuantity = element.Quantity * element.RentQuantity

          element.RentWarrantyPeriod = this.editedMonthItem.RentWarrantyPeriod
          element.PayType = this.editedMonthItem.PayType
          element.PayTimeRangeType = this.editedMonthItem.PayTimeRangeType
          element.PayQuantityType = this.editedMonthItem.PayQuantityType
          const quantityMultiplier =
            element.PayType === this.payType.Quantity
              ? Math.max(0, element.AddPayQuantity + element.PayQuantity)
              : 1
          if (index === 0) {
            element.Discount = this.editedMonthItem.Discount
            element.DiscountPrice = element.Price - element.Discount
            element.TotalPrice = element.DiscountPrice * element.TotalQuantity * quantityMultiplier
          } else {
            element.Discount = 0
            element.DiscountPrice = element.Price
            element.TotalPrice = element.Price * element.TotalQuantity * quantityMultiplier
          }
        })
        this.$emit('setMonthItem', this.editedMonthItem)
        this.closeEditedBomMonthItem()
      }
    },
    closeEditedBomMonthItem () {
      this.isShowEditBomMonthItemDialog = false
      this.$nextTick(() => {
        this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
        this.editedMonthItemIndex = -1
        this.editedMonthBomItemIndex = -1
        this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
        this.$emit('setMonthBomItemIndex', this.editedMonthBomItemIndex)
      })
    },
    isShowDeleteMonthItemDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number) {
        this.editedMonthItemIndex = mainIndex
        this.editedMonthBomItemIndex = subIndex
        this.isShowDeleteBomMonthItemDialog = true
      } else {
        this.editedMonthBomItemIndex = subIndex
        this.editedMonthItemIndex = mainIndex
        this.isShowDeleteMonthItemDialog = true
      }
    },
    confirmDeleteBomMonthItem () {
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
      this.$emit('setMonthBomItemIndex', this.editedMonthBomItemIndex)
      this.$emit('deleteMonthItem')
      this.closeDeleteBomMonthItem()
    },
    closeDeleteBomMonthItem () {
      this.isShowDeleteBomMonthItemDialog = false
      this.$nextTick(() => {
        this.editedMonthItemIndex = -1
        this.editedMonthBomItemIndex = -1
        this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
        this.$emit('setMonthBomItemIndex', this.editedMonthBomItemIndex)
      })
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType'
  ]
}
</script>
